import { atom } from "jotai";

import { selectedRoundAtom } from "../../stores";

export const getRateOnRoundAtom = atom((get) => {
  const selectedRound = get(selectedRoundAtom);
  return selectedRound?.rate || null;
});
